define([
    './globals',
    'jquery',
    './helpers/console',
    'config',
], function (globals, $, console, config) {

    var modal = require('./modal');
    var cookie_policy = require('./cookie_policy');
    var emo = require('./emo');
    var external_links = require('./external_links');
    var lazySizes = require('./helpers/lazysizes-umd');
    var galleryPreview = require('./gallery');

    var equalizeCols = require('./helpers/equalize_cols');
    var mobileNav = require('./mobile_nav');

    var seria = require('./seria');
    var grid = require('./grid');
    var home_grid = require('./home_grid');
    var series_list = require('./series_list');

    var form_contact = require('./form_contact');
    var form_seria = require('./form_seria');

    var mini_cart = require('./mini_cart');
    var cart = require('./cart');
    var checkout = require('./checkout');

    var init = function() {
        $(function () {
            // modal.init();
            external_links();
            emo();
            cookie_policy.init();
            equalizeCols.init();
            mobileNav.init();

            seria.init();
            grid.init();
            home_grid.init();
            series_list.init();
            galleryPreview.init();

            form_contact.init();
            form_seria.init();

            mini_cart.init();
            cart.init();
            checkout.init();
        });
    };

    return {
        init: init
    };
});